<mat-dialog-content>
  <rpe-registro-actividad-almacenamiento [formInput]="deposito" (formStatusChanges)="formStatusChange($event)"
    (formValueChanges)="formValueChange($event)"></rpe-registro-actividad-almacenamiento>
  <div class="action">
    <button (click)="onCancel()" mat-raised-button>
      Cerrar
    </button>
    <button (click)="onAdd()" mat-raised-button>
      Registrar
    </button>
  </div>
</mat-dialog-content>
